/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbExamenEntreeGridDto } from './FcbExamenEntreeGridDto';
import {
    FcbExamenEntreeGridDtoFromJSON,
    FcbExamenEntreeGridDtoFromJSONTyped,
    FcbExamenEntreeGridDtoToJSON,
} from './FcbExamenEntreeGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbExamenEntreeGridDtoPaginatedResults
 */
export interface FcbExamenEntreeGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbExamenEntreeGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbExamenEntreeGridDto>}
     * @memberof FcbExamenEntreeGridDtoPaginatedResults
     */
    results?: Array<FcbExamenEntreeGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbExamenEntreeGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbExamenEntreeGridDtoPaginatedResults interface.
 */
export function instanceOfFcbExamenEntreeGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbExamenEntreeGridDtoPaginatedResultsFromJSON(json: any): FcbExamenEntreeGridDtoPaginatedResults {
    return FcbExamenEntreeGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbExamenEntreeGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbExamenEntreeGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbExamenEntreeGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbExamenEntreeGridDtoPaginatedResultsToJSON(value?: FcbExamenEntreeGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbExamenEntreeGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

